import useApi from '../hook/useApi';

const useDocumentsApi = () => {
  const { sendRequest, loading, data, error } = useApi();

  const getDocsData = async (page = 1, search = "", type = "", status = "") => {
    return sendRequest(`/imp/documents_screen/get_all_documents?page=${page}&limit=10&search=${search}&documentType=${type}&document_status=${status}`, 'GET', {});
  };

  return {
    getDocsData,
    loading,
    data,
    error,
  };
};

export default useDocumentsApi;